import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["messages", "activity", "composer"]

  activityTargetConnected() {
    this.updateActivity()
  }

  connect() {
    this.observer = new MutationObserver(() => {
      this.revealPlaceholders()
      this.reconcileMessageOrder()
      this.updateComposerPlaceholder()
      this.scrollToBottom()
    })
    this.observer.observe(this.messagesTarget, {
      childList: true,
      characterData: true,
      subtree: true
    })
    this.revealPlaceholders()
    this.reconcileMessageOrder()
    this.updateComposerPlaceholder()
    this.scrollToBottom()
  }

  disconnect() {
    this.observer.disconnect()
  }

  submit(event) {
    if (event.key !== "Enter" || event.shiftKey || event.ctrlKey || event.altKey || event.metaKey || event.isComposing) return

    event.preventDefault()
    if (!event.repeat) event.target.form.requestSubmit()
  }

  startThinking(event) {
    const submitter = event.detail?.formSubmission?.submitter
    const submitted = submitter?.name === "message[content]" ? submitter.value : null
    const content = submitted?.trim() ? submitted : new FormData(event.target).get("message[content]")
    if (!content?.trim()) return

    this.activityTarget.dataset.state = "working"
    this.updateActivity()
  }

  finishSubmission(event) {
    if (event.detail.success) return

    this.activityTarget.dataset.state = "error"
    this.updateActivity()
  }

  revealPlaceholders() {
    this.messagesTarget.querySelectorAll('[data-message-placeholder="true"]').forEach((message) => {
      const content = message.querySelector("[data-message-body]")?.textContent ?? ""
      const thinking = message.querySelector("[data-message-thinking]")?.textContent ?? ""
      if (!content.trim() && !thinking.trim()) return

      message.dataset.messagePlaceholder = "false"
      message.classList.remove("hidden", "max-w-[85%]")
      message.classList.add("flex", "w-full", "flex-col", "items-start")
    })
  }

  reconcileMessageOrder() {
    const container = this.messagesTarget.querySelector("#messages") ?? this.messagesTarget
    const messages = Array.from(container.children).filter(message => message.dataset.messageCreatedAt)
    const ordered = [...messages].sort((left, right) => {
      const timestampOrder = Date.parse(left.dataset.messageCreatedAt) - Date.parse(right.dataset.messageCreatedAt)
      return timestampOrder || Number(left.dataset.messageId) - Number(right.dataset.messageId)
    })

    if (messages.some((message, index) => message !== ordered[index])) container.append(...ordered)
  }

  updateActivity() {
    this.messagesTarget.setAttribute("aria-busy", this.activityTarget.dataset.state === "working")
    this.scrollToBottom()
  }

  updateComposerPlaceholder() {
    if (!this.hasComposerTarget) return

    const hasMessages = this.messagesTarget.querySelector("#messages > [id^='message_']")
    this.composerTarget.placeholder = hasMessages ? "Ask a follow up" : "Ask about giving…"
  }

  scrollToBottom() {
    this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
  }
}
